
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6ed1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6ed1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ce450734fdab8686$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9Ibp0","index.a4372555.js","8MYB7","icon-error.1e4fe8e7.svg"]'));

const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


const $e28257c94f1ecb93$export$ca000e230c0caa3e = {
    signupInformation: {
        id: "",
        emailID: ""
    }
};
const $e28257c94f1ecb93$export$7200a869094fec36 = function(newSignup) {
    try {
        const emailID = newSignup.emailID;
        let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (emailID) {
            if (emailID.match(regex)) {
                const signupInfo = {
                    id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                    email_ID: newSignup.emailID
                };
                const signupJSON = JSON.stringify(signupInfo);
                $e28257c94f1ecb93$export$ca000e230c0caa3e.signupInformation.id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
                $e28257c94f1ecb93$export$ca000e230c0caa3e.signupInformation.emailID = newSignup.emailID;
            } else throw new Error("Please Enter a Valid Email Address.");
        } else throw new Error("Please Enter a Valid Email Address.");
    } catch (error) {
        throw error;
    }
};


const $177d492998fbed73$export$c3067053ab62d876 = 11;
const $177d492998fbed73$export$7bedb3adee70aa5e = 10;


var $b332745c4baaf380$exports = {};
$b332745c4baaf380$exports = new URL("icon-error.1e4fe8e7.svg", import.meta.url).toString();



class $b25a28c18d0ab575$export$2e2bcd8739ae039 {
    intervalId;
    cuntdown = document.querySelector("#cuntdown");
    _clearErrorMessage() {
        this._parentElementError.innerHTML = "";
        this._parentElementError.classList.remove("error-message--extend");
        this._email.classList.remove("invalid-email-id");
    }
    showMessageContainer() {
        this._signupContainer.classList.add("hidden");
        this._successMessageContainer.classList.remove("hidden");
        this._email.value = "";
        this.cuntdown.textContent = $177d492998fbed73$export$7bedb3adee70aa5e;
        this._email.classList.remove("invalid-email-id");
    }
    hideMessageContainer() {
        this._signupContainer.classList.remove("hidden");
        this._successMessageContainer.classList.add("hidden");
        this._email.value = "";
        this.cuntdown.textContent = $177d492998fbed73$export$7bedb3adee70aa5e;
        location.reload();
        this._email.classList.remove("invalid-email-id");
    }
    renderError(message = this._errorMessage) {
        const murkup = `
    <img class="error-icon" src="${(0, (/*@__PURE__*/$parcel$interopDefault($b332745c4baaf380$exports)))}" alt="error icon">
    <p>${message}</p>`;
        this._clearErrorMessage();
        this._parentElementError.classList.add("error-message--extend");
        this._email.classList.add("invalid-email-id");
        this._email.focus();
        this._parentElementError.insertAdjacentHTML("afterbegin", murkup);
    }
    renderEmailAddress(emailID) {
        this._emailID.innerHTML = emailID;
    }
    startInterVal() {
        this.intervalId = setInterval(this.renderCountdown, 1000);
    }
    renderCountdown() {
        let countDownValue = +this.cuntdown.textContent;
        if (countDownValue > 0) {
            --countDownValue;
            this.cuntdown.textContent = countDownValue;
            console.log(countDownValue);
        } else clearInterval(this.intervalId);
    }
}



class $788c04d4fda2883f$var$SignupView extends (0, $b25a28c18d0ab575$export$2e2bcd8739ae039) {
    _parentElementSignup = document.querySelector(".signup");
    _parentElementError = document.querySelector(".error-message");
    _errorMessage = "Please enter a valid email address.";
    _signupContainer = document.querySelector(".signup-container");
    _successMessageContainer = document.querySelector(".success-message-container");
    _emailID = document.querySelector(".email-id");
    _email = document.querySelector("#email");
    _dismissBtn = document.querySelector(".dismiss__btn");
    constructor(){
        super();
    }
    addHandlerSignup(handler) {
        this._parentElementSignup.addEventListener("submit", function(event) {
            event.preventDefault();
            const dataArray = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArray);
            handler(data);
        });
    }
    addHandlerDismiss(handler) {
        this._dismissBtn.addEventListener("click", function(event) {
            event.preventDefault();
            handler();
        });
    }
}
var $788c04d4fda2883f$export$2e2bcd8739ae039 = new $788c04d4fda2883f$var$SignupView();


const $562d4a0d1cb54a27$var$controlSignup = function(newSignup) {
    try {
        $e28257c94f1ecb93$export$7200a869094fec36(newSignup);
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).renderEmailAddress($e28257c94f1ecb93$export$ca000e230c0caa3e.signupInformation.emailID);
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039)._clearErrorMessage();
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).showMessageContainer();
        setTimeout(function() {
            (0, $788c04d4fda2883f$export$2e2bcd8739ae039).hideMessageContainer();
        }, $177d492998fbed73$export$c3067053ab62d876 * 1000);
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).startInterVal();
    } catch (error) {
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).renderError(error.message);
        setTimeout(function() {
            (0, $788c04d4fda2883f$export$2e2bcd8739ae039)._clearErrorMessage();
        }, $177d492998fbed73$export$7bedb3adee70aa5e * 1000);
    }
};
const $562d4a0d1cb54a27$var$controlDismissMessage = function() {
    try {
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).hideMessageContainer();
    } catch (error) {
        (0, $788c04d4fda2883f$export$2e2bcd8739ae039).renderError(error.message);
    }
};
const $562d4a0d1cb54a27$var$init = function() {
    (0, $788c04d4fda2883f$export$2e2bcd8739ae039).addHandlerSignup($562d4a0d1cb54a27$var$controlSignup);
    (0, $788c04d4fda2883f$export$2e2bcd8739ae039).addHandlerDismiss($562d4a0d1cb54a27$var$controlDismissMessage);
};
$562d4a0d1cb54a27$var$init();


//# sourceMappingURL=index.a4372555.js.map
